<template>
    <div v-if="visible" class="modal-container">
        <!-- 遮罩层 -->
        <div class="modal-mask" @click="handleMaskClick" :style="{ backgroundColor: maskColor, opacity: maskOpacity }">
        </div>
        <!--主体内容-->
        <div style="position: relative; z-index: 9999;" class="prepaid-card">
            <div class="prepaid-card-box">
                <div class="prepaid-box">
                    <div style="height: 51px;"></div>
                    <div class="prepaid-title">预付卡信息查询</div>
                    <div style="height: 46px;"></div>
                    <!---预付卡填写信息--->
                    <div class="prepaid_card">
                        <div class="prepaid_card_info">
                            <div class="prepaid_card_txt">请先在「熊猫引才」小程序中完成会员激活与信息绑定</div>
                             <div style="height: 17px;"></div>
                            <div class="info-input">
                                <div class="input-labe">
                                    <div class="required">*</div>
                                    <div class="required-title">身份证号</div>
                                </div>
                                <div style="width:18px;"></div>
                                <div class="input-txt">
                                    <div style="width: 12px;"></div>
                                    <input v-model="codeId" class="custom-input" type="text" placeholder="请输入个人身份证号"
                                        style="border: none; outline: none;">
                                </div>
                            </div>
                            <div style="height: 12px;"></div>
                             <div class="info-input">
                                <div class="input-labe">
                                    <div class="required">*</div>
                                    <div class="required-title">学员姓名</div>
                                </div>
                                <div style="width:18px;"></div>
                                <div class="input-txt">
                                    <div style="width: 12px;"></div>
                                    <input v-model="userName" class="custom-input" type="text" placeholder="请输入学员姓名"
                                        style="border: none; outline: none;">
                                </div>
                            </div>
                        </div>
                        <div class="prepaid_card_division"></div>
                        <div class="prepaid_card_qr_code">
                            <div class="prepaid_card_qr_code_txt">如未激活请微信扫描下方二维码进行信息绑定</div>
                             <div style="height: 5px;"></div>
                            <img src="../../assets/logo.png" style="width: 114px; height: 114px;"/>
                        </div>
                    </div>




                    <!--取消和确认按钮-->
                    <div style="height: 32px"></div>
                    <div class="cancel-and-query">
                        <div class="cancel" @click="handleCancel">取消</div>
                        <div style="width: 18px"></div>
                        <div class="query">
                            <div class="query-box" @click="queryMethod">
                                <div class="query-txt">立即查询</div>
                                <div style="width: 8px;"></div>
                                <img src="../../assets/popUp/jt.png" style="width: 14px; height: 12px;" />
                            </div>
                        </div>
                        <div style="width: 65px;"></div>
                    </div>

                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Modal',
    props: {
        // 是否显示弹窗
        visible: {
            type: Boolean,
            default: false
        },
        // 弹窗标题
        title: {
            type: String,
            default: ''
        },
        // 弹窗宽度
        width: {
            type: String,
            default: '500px'
        },
        // 弹窗最大宽度
        maxWidth: {
            type: String,
            default: '90vw'
        },
        // 是否居中显示
        center: {
            type: Boolean,
            default: true
        },
        // 是否显示关闭按钮
        closable: {
            type: Boolean,
            default: true
        },
        // 是否显示头部
        showHeader: {
            type: Boolean,
            default: true
        },
        // 是否显示底部
        showFooter: {
            type: Boolean,
            default: true
        },
        // 点击遮罩是否关闭
        maskClosable: {
            type: Boolean,
            default: true
        },
        // 遮罩层颜色
        maskColor: {
            type: String,
            default: 'rgba(0, 0, 0, 0.5)'
        },
        // 遮罩层透明度
        maskOpacity: {
            type: Number,
            default: 0.8
        },
        // 弹窗背景颜色
        backgroundColor: {
            type: String,
            default: '#fff'
        }
    },
    data() {
        return {
            codeId: '',
            userName: '',
        }
    },
    methods: {
        queryMethod() {
            console.log("点我干嘛");
            if (!this.codeId) {
                this.$message.error('请输入个人身份证号');
                return;
            }
            if (!this.userName) {
                this.$message.error('请输入学员姓名');
                return;
            }
        },
        // 点击关闭按钮
        handleClose() {
            this.$emit('close');
            this.$emit('update:visible', false);
        },
        // 点击取消按钮
        handleCancel() {
            this.$emit('cancel');
            this.$emit('update:visible', false);
        },
        // 点击确认按钮
        handleConfirm() {
            this.$emit('confirm');
            this.$emit('update:visible', false);
        },
        // 点击遮罩层
        handleMaskClick() {
            if (this.maskClosable) {
                this.handleClose();
            }
        }
    }
};
</script>

<style scoped>

.prepaid_card_qr_code_txt{
    width: 284px;
height: 20px;
font-family: PingFangSC, PingFang SC;
font-weight: 400;
font-size: 14px;
color: #171A1D;
line-height: 20px;
text-align: left;
font-style: normal;
}

.prepaid_card_division{
    border-radius: 30px;
    width: 1px;
    border-left:  2px solid rgba(23, 26, 29, 0.1);
}

.prepaid_card_txt{
    width: 360px;
height: 20px;
font-family: PingFangSC, PingFang SC;
font-weight: 600;
font-size: 14px;
color: #FF6E00;
line-height: 20px;
letter-spacing: 1px;
text-align: center;
font-style: normal;
}

.prepaid_card_info{
    width: 360px;
}

.prepaid_card {
    width: 729px;
    display: flex;
    justify-content: space-between;
    margin: 0 auto;
}

.cancel-and-query {
    display: flex;
    justify-content: flex-end;
}

.query-box {
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
}

.query-txt {
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    font-size: 14px;
    color: #FFFFFF;
    line-height: 22px;
    text-align: center;
    font-style: normal;
}

.query {
    width: 120px;
    height: 42px;
    background: linear-gradient(228deg, #FF6503 0%, #FF8012 100%);
    box-shadow: inset 0px 1px 3px 0px rgba(255, 255, 255, 0.5);
    border-radius: 21px;
    display: flex;
    justify-content: center;
}


.cancel {
    width: 76px;
    height: 42px;
    background: #FFFFFF;
    border-radius: 21px;
    border: 1px solid rgba(126, 134, 142, 0.24);

    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 14px;
    color: #171A1D;
    line-height: 42px;
    text-align: center;
    font-style: normal;
    cursor: pointer;

}

.custom-input {
    width: 272px;
    border-radius: 10px
}

.custom-input::placeholder {
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 14px;
    color: rgba(23, 26, 29, 0.4);
    line-height: 20px;
    text-align: left;
    font-style: normal;
}

.input-txt {
    width: 400px;
    height: 46px;
    background: #FFFFFF;
    border-radius: 6px;
    border: 1px solid rgba(126, 134, 142, 0.24);
    display: flex;
}


.required-title {
    width: 64px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 13px;
    color: #171A1D;
    line-height: 20px;
    text-align: left;
    font-style: normal;
}

.required {
    color: rgba(255, 82, 25, 1);
    margin-top: 2px;
}

.input-labe {
    display: flex;
    justify-content: flex-end;
    width: 106px;
}

.info-input {
    display: flex;
    justify-content: center;
    align-items: center;
}

.prepaid-card {
    width: 865px;
    height: 410px;
    box-shadow: 0px 6px 10px 0px rgba(192, 192, 192, 0.15);
    border-radius: 16px;
    background: linear-gradient(180deg, rgba(255, 102, 3, 1) 0%, rgba(255, 255, 255, 0.6) 100%);
    backdrop-filter: blur(10px);
    display: flex;
    justify-content: center;
    align-items: center;
}

.prepaid-card-box {
    width: 862px;
    height: 408px;
    background: #FFFFFF;
    box-shadow: 0px 6px 10px 0px rgba(192, 192, 192, 0.15);
    border-radius: 16px;
    backdrop-filter: blur(10px);
}

.prepaid-box {
    margin: 0 auto;
}

.prepaid-title {
    font-family: PingFangSC, PingFang SC;
    font-weight: 600;
    font-size: 24px;
    color: #171A1D;
    line-height: 33px;
    text-align: center;
    font-style: normal;
}


.modal-container {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 1000;
    overflow: auto;
    display: flex;
    align-items: center;
    justify-content: center;
}

.modal-mask {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    transition: opacity 0.3s;
}

.modal-content {
    position: relative;
    margin: 100px auto 50px;
    border-radius: 4px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
    transition: all 0.3s;
}

.modal-center {
    top: 50%;
    transform: translateY(-50%);
    margin: 0 auto;
}

.modal-header {
    padding: 16px 20px;
    border-bottom: 1px solid #e8e8e8;
    position: relative;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.modal-title {
    margin: 0;
    font-size: 16px;
    font-weight: 500;
    color: #1f2329;
}

.modal-close {
    background: transparent;
    border: none;
    font-size: 20px;
    cursor: pointer;
    color: #9aa0a6;
    width: 32px;
    height: 32px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: background-color 0.2s;
}

.modal-close:hover {
    background-color: #f5f5f5;
    color: #1f2329;
}

.modal-body {
    padding: 20px;
    font-size: 14px;
    line-height: 1.5;
}

.modal-footer {
    padding: 10px 20px;
    border-top: 1px solid #e8e8e8;
    text-align: right;
}

.modal-btn {
    padding: 6px 16px;
    border-radius: 4px;
    font-size: 14px;
    cursor: pointer;
    transition: all 0.2s;
    border: 1px solid #d9d9d9;
    margin-left: 8px;
}

.modal-btn-cancel {
    background-color: #fff;
    color: #1f2329;
}

.modal-btn-cancel:hover {
    background-color: #f5f5f5;
}

.modal-btn-confirm {
    background-color: #1890ff;
    color: #fff;
    border-color: #1890ff;
}

.modal-btn-confirm:hover {
    background-color: #096dd9;
    border-color: #096dd9;
}
</style>


// WEBPACK FOOTER //
// src/components/MaskLayer/maskLayer.vue